import React from "react";
import { Icons, IconButton, Tooltip } from "@curves/ui-base";

const TemporaryDeleteActionBar = props => {
	const { getResult: getResultProps = () => {}, dialogRef, refresh: refreshProps } = props;

	const handleClick = () => {
		const targetData = getResultProps();
		if (dialogRef && dialogRef.current && targetData.list.length !== 0) dialogRef.current.openNonMemberTemporaryDeleteRecord(targetData, refreshProps);
	};

	return (
		<Tooltip title={"刪除"}>
			<IconButton onClick={handleClick}>
				<Icons.Trash />
			</IconButton>
		</Tooltip>
	);
};

export default TemporaryDeleteActionBar;
